@if (pdfSrc$ | async; as pdfSrc) {
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    [showHandToolButton]="true"
    [height]="'100%'"
    [zoom]="'page-width'"
    [spread]="'off'"
    [showSidebarButton]="false"
    [showFindButton]="true"
    [showPagingButtons]="true"
    [showZoomButtons]="true"
    [showPresentationModeButton]="false"
    [showOpenFileButton]="false"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [showSecondaryToolbarButton]="true"
    [showRotateButton]="true"
    [showScrollingButtons]="true"
    [showSpreadButton]="false"
    [showPropertiesButton]="false"
    [textLayer]="false"
    [minZoom]="0.1"
    [maxZoom]="10"
    [mobileFriendlyZoom]="'100%'"
    [ignoreKeyboard]="true"
    [ignoreKeys]="['cmd++', 'cmd+-', 'ctrl++', 'ctrl+-', '+', '-']"
    (pdfLoaded)="onPdfLoaded()"
    #pdfViewer>
  </ngx-extended-pdf-viewer>
}

@if (loading$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
